import { render } from "./SideMenu.vue?vue&type=template&id=8a3fe080"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "8a3fe080"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a3fe080', script)) {
    api.reload('8a3fe080', script)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=8a3fe080", () => {
    api.rerender('8a3fe080', render)
  })

}

script.__file = "src/views/settings/modules/SideMenu.vue"

export default script